<template>
    <div class="pintuan">
        <div class="top-banner">
            <div>
                <div  :style="tittlestyle" class="fl tittle">
                    <h2>产品中心-拼团</h2>
                    <p>社交电商时代营销利器，快速扩张传播卖货，帮助您降低库存回笼资金</p>
                </div>
                <img  src="/site_static/img/product-ban.png" alt="" class="fr banner-img" :style="banlogostyle">
            </div>
        </div>
        <div class="flex member marginauto" style="padding-bottom: 50px;">
            <div style="width: 1200px;margin: 0 auto;">
                <div class="member-left" style="width: 530px;float: left;margin-top: 70px;" >
                    <div class="member-tit">增加销量加快资金回流</div>
                    <div class="member-subtit">快速积累人气和流量，帮助您缓解库存压力，快速卖货，回笼资金，提升订单成交率</div>
                </div>
                <img src="/site_static/img/fastsell.png" class="member-right">
            </div>
        </div>
        <div style="background: #f5f8ff;">
            <div class="flex member marginauto">
                <img src="/site_static/img/talk.png" class="member-right" style="padding: 0 80px;">
                <div class="member-left" style="width: 600px;">
                    <div class="member-tit">社交分享传播，提升商城影响力</div>
                    <div class="member-subtit">自带10亿微信活跃用户，指数级裂变传播，迅速增加商城曝光率，提高知名度推动商品销量大爆发</div>
                </div>
            </div>
        </div>
        <div class="flex member marginauto" style="padding-bottom: 50px;">
            <div class="member-left" style="width: 530px;">
                <div class="member-tit">唤醒沉睡会员促活商城</div>
                <div class="member-subtit">唤回老会员参与商城拼团活动，通过拼团超低价格吸引老用户参与带动新用户加入，促进订单达成，提升成交率</div>
            </div>
            <img src="/site_static/img/wakeup.png" class="member-right">
        </div>
        <div class="poster">
            <div class="title" style="padding: 50px 0 30px 0">
                <h3>拼团页面展示</h3>
            </div>
            <div class="flex poster-container marginauto">
                <div class="poster-item">
                    <img src="/site_static/img/group1.png">
                    <p class="poster-subtit">拼团商品详情</p>
                </div>
                <div class="poster-item">
                    <img src="/site_static/img/group2.png">
                    <p class="poster-subtit">拼团支付成功</p>
                </div>
                <div class="poster-item">
                    <img src="/site_static/img/group3.png">
                    <p class="poster-subtit">拼团商品列表</p>
                </div>
            </div>
        </div>
        <div class="group-special">
            <div class="title" style="padding: 50px 0 24px 0">
                <h3>微涟拼团的特色</h3>
            </div>
            <div class="flex special-container">
                <div style="text-align: right;">
                    <div class="special-item">
                        <div class="special-tit">基于微信社交场景</div>
                        <p class="special-subtit">充分利用微信最大流量入口，通过社交分享</p>
                        <p class="special-subtit">快速引爆电商市场</p>
                    </div>
                    <div class="special-item">
                        <div class="special-tit">去中心化推广传播</div>
                        <p class="special-subtit">每位会员自带推广流量，带给您更广阔的宣传</p>
                        <p class="special-subtit">空间和无限商机</p>
                    </div>
                </div>
                <img src="/site_static/img/groupspe.png" alt="">
                <div style="text-align: left;">
                    <div class="special-item">
                        <div class="special-tit">碎片场景营销</div>
                        <p class="special-subtit">利用碎片化场景分享拼团商品，迅速挖掘潜在</p>
                        <p class="special-subtit">用户促进订单达成</p>
                    </div>
                    <div class="special-item">
                        <div class="special-tit">多元化分享传播</div>
                        <p class="special-subtit">通过朋友圈、微信好友、链接、海报等形式，</p>
                        <p class="special-subtit">帮助您推广宣传</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="poster">
            <div class="title" style="padding: 50px 0 30px 0">
                <h3>解决三大拼团活动痛点</h3>
            </div>
            <div class="flex poster-container marginauto">
                <div class="pain-item">
                    <img src="/site_static/img/pain1.png" alt="">
                    <p class="pain-tit">推广传播难</p>
                    <p class="pain-subtit">微涟拼团基于微信平台传播，自带流量，实现病毒式裂变传播，轻松推广传播。</p>
                </div>
                <div class="pain-item">
                    <img src="/site_static/img/pain2.png">
                    <p class="pain-tit">宣传成本高</p>
                    <p class="pain-subtit">微涟拼团活动可打通线上渠道打造宣传闭环，运营投入成本少，宣传效果显著。</p>
                </div>
                <div class="pain-item">
                    <img src="/site_static/img/pain3.png">
                    <p class="pain-tit">订单转化少</p>
                    <p class="pain-subtit">微涟拼团系统可一键分享邀请海量好友参与团购，可快速引流降低库存积压。</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'pintuan',
        data(){
            return{
                tittlestyle:{},
                banlogostyle:{}
            }
        },
        created: function () {
            let serf = this
            setTimeout(function () {
                serf.tittlestyle={
                    bottom:'125px',
                    opacity: 1}
                serf.banlogostyle={
                    bottom:'45px',
                    opacity: 1}
            },0)

        }
    }
</script>
<style scoped>
    p{
        margin: 0;
    }
    .flex{
        display: flex;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .top-banner{
        background: linear-gradient(90deg,#ff5870,#ff8b54);
        color: #fff;
        width: 100%;
        height: 480px;
    }
    .top-banner>div{
        width: 1200px;
        margin: auto;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tittle{
        position: absolute;
        height: 220px;
        transition: all .5s;
        bottom: 0;
        opacity: 0;
    }
    .tittle>h2{
        font-size: 30px;
        margin: 50px 20px 28px 0;
        font-weight: 500;
    }
    .tittle>p{
        font-size: 18px;
        width: 500px;
        line-height: 36px;
        margin-bottom: 30px;
        text-align: left;
    }
    .banner-img{
        position: absolute;
        bottom: 0px;
        opacity: 0;
        transition: all .5s;
    }
    .member {
        align-items: center;
        padding-top: 50px;
    }
    .member-left {
        padding-left: 40px;
    }
    .member-tit {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 24px;
    }
    .member-subtit {
        line-height: 30px;
        font-size: 18px;
        color: #5d6494;
    }
    .member-right {
        padding-left: 20px;
    }
    .member {
        align-items: center;
        padding-top: 50px;
    }
    .marginauto {
        margin: 0 auto;
        width: 1200px;
    }
    .poster {
        background: #f5f8ff;
    }
    .title {
        padding: 80px 0 50px 0;
        text-align: center;
    }
    .title h3 {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
    }
    .poster-container {
        padding-bottom: 50px;
        justify-content: center;
    }
    .marginauto {
        margin: 0 auto;
        width: 1200px;
    }
    .poster-item {
        margin: 0 15px;
    }
    .poster-subtit {
        font-size: 14px;
        color: #5d6494;
        text-align: center;
        padding-top: 28px;
    }
    .poster-item img{
        width: 297px;
        height: 481px;
    }
    .special-container {
        justify-content: center;
        padding-bottom: 50px;
    }
    .special-item {
        font-size: 14px;
        color: #5D6494;
        line-height: 26px;
        margin-top: 92px;
    }
    .special-item .special-tit {
        font-size: 18px;
        color: #3B426B;
        padding-bottom: 10px;
    }
    .special-container img {
        margin: 0 38px;
    }
    .pain-item {
        margin: 0 19px;
        width: 320px;
        height: 358px;
        background: linear-gradient(360deg,#ff5870,#ff8b54);
        color: #FFFFFF;
        text-align: center;
        font-size: 20px;
    }
    .pain-item img {
        padding: 64px 0 32px 0;
        margin: 0 auto;
    }
    .pain-subtit {
        opacity: .5;
        font-size: 16px;
        line-height: 34px;
        padding-top: 16px;
        width: 256px;
        margin: 0 auto;
        text-align: left;
    }
    .commission{
        background: url(/site_static/img/free.png) no-repeat;
        background-size: 100% 100%;
        height: 240px;
        text-align: center;
        padding-top: 50px;
        box-sizing: border-box;
        color: #fff;
    }
    .commission-tit {
        font-size: 28px;
        padding-bottom: 16px;
    }
    .commission .free {
        width: 116px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #fff;
        margin: 0 auto;
        margin-top: 8px;
    }




</style>



// WEBPACK FOOTER //
// src/components/product/pintuan.vue